/**
 * "New design" item of the user menu: the header avatar dropdown on desktop
 * and the profile navigation on mobile (≤900px the avatar opens /profile
 * instead of a dropdown). Mirror of profile-new's "Класичний дизайн" item.
 *
 * The click is reported through the site's EXISTING GTM dataLayer FIRST (GA4
 * sends via sendBeacon, so the hit survives the unload), then the session is
 * handed off through the gs_handoff cookie — see src/utils/designSwitch.js
 * and profile-new's docs/DESIGN-SWITCH.md for the contract.
 */

import { mapGetters } from "vuex";
import * as Sentry from "@sentry/vue";
import { trackEvent } from "@/utils/analytics";
import { switchToNewDesign } from "@/utils/designSwitch";
import { interfaceT } from "@/utils/interfaceTranslationFallbacks";

export const DESIGN_SWITCH_CLICK_EVENT = "design_switch_click";

export default {
	data() {
		return {
			isSwitchingDesign: false,
		};
	},
	computed: {
		...mapGetters({
			isAuthenticated: "auth/isAuthenticated",
		}),
		newDesignLabel() {
			return interfaceT(this, this.isSwitchingDesign ? "newDesignSwitching" : "newDesign");
		},
	},
	mounted() {
		window.addEventListener("pageshow", this.resetDesignSwitch);
	},
	beforeDestroy() {
		window.removeEventListener("pageshow", this.resetDesignSwitch);
	},
	methods: {
		switchToNewDesign() {
			// The first click already wrote the cookie and started the
			// navigation — a second one would only duplicate the event.
			if (this.isSwitchingDesign) {
				return;
			}

			this.isSwitchingDesign = true;

			try {
				trackEvent(DESIGN_SWITCH_CLICK_EVENT, { from: "old", to: "new" });
				switchToNewDesign();
			} catch (e) {
				Sentry.captureException(e);

				this.isSwitchingDesign = false;
				this.$toasted.error(interfaceT(this, "newDesignSwitchFailed"));
			}
		},
		// Going "back" restores this page from bfcache with the item still
		// stuck in its loading state — make it clickable again.
		resetDesignSwitch(event) {
			if (event && event.persisted) {
				this.isSwitchingDesign = false;
			}
		},
	},
};
